import request from '@/utils/request'

const http = request()

export const saveStagePlan = params => http.raw(params.nextStep ? '/project/stageplan/submit' : '/project/stageplan/save', params)

export const listStagePlan = params => http.post('/project/stageplan/list', params)

export const reviewStagePlan = params => http.post('/project/stageplan/review', params)

export const getStagePlan = stagePlanId => http.post('/project/stageplan/get', { stagePlanId })

export const getStagePlanProjects = stagePlanId => http.post('/project/stageplan/projects', { stagePlanId })

export const updateStagePlanProjects = params => http.raw('/project/stageplan/updateProjects', params)

export const delStagePlan = stagePlanId => http.post('/project/stageplan/delete', { stagePlanId })

export const submitTaskArchive = params => http.post('/project/stageplan/archive/submit', params)

export const reviewTaskArchive = params => http.post('/project/stageplan/archive/review', params)
